module.exports = __webpack_public_path__ + "static/assets/b1a1083af6320c24b608246af62ea202.png";